module.exports = __webpack_public_path__ + "static/media/brochure-jenkins-logo.63564fc8.webp";